// Adaptive homepage-showcase layout. Column counts are chosen to keep the grid
// balanced and minimise orphan cards for ANY count from 1 to 12. Shared by the
// storefront homepage and the Admin live preview so they always match.
// NOTE: class strings are LITERAL (not interpolated) so Tailwind's JIT keeps them.
const GRID = {
  1: "grid gap-4 grid-cols-1",
  2: "grid gap-4 grid-cols-1 sm:grid-cols-2",
  3: "grid gap-4 grid-cols-2 lg:grid-cols-3",
  4: "grid gap-4 grid-cols-2 lg:grid-cols-4",
  5: "grid gap-4 grid-cols-2 lg:grid-cols-3",
  6: "grid gap-4 grid-cols-2 lg:grid-cols-3",
  7: "grid gap-4 grid-cols-2 lg:grid-cols-4",
  8: "grid gap-4 grid-cols-2 lg:grid-cols-4",
  9: "grid gap-4 grid-cols-2 lg:grid-cols-3",
  10: "grid gap-4 grid-cols-2 lg:grid-cols-4",
  11: "grid gap-4 grid-cols-2 lg:grid-cols-4",
  12: "grid gap-4 grid-cols-2 lg:grid-cols-4",
};

export const showcaseGridClass = (count) => GRID[Math.max(1, Math.min(12, count || 1))] || GRID[4];

// Per-card sizing: uniform heights (so rows align cleanly) + optional "wide" cards
// that span two columns for a premium bento feel. A single card becomes a full-width
// cinematic feature.
export const showcaseCardClass = (card, count) => {
  const single = (count || 1) === 1;
  const wide = card?.width === "wide" && !single;
  const height = single
    ? "h-[360px] sm:h-[460px]"
    : "h-[260px] sm:h-[300px] lg:h-[340px]";
  return `${height} ${wide ? "col-span-2" : ""}`.trim();
};
